export const SITE_URL = "http://www.amplifiedbydesign.com"

export const CLOUDINARY_URL =
  "https://res.cloudinary.com/amplifiedbydesign/image/upload"

export const ADOBE_FONTS_ID = "six3dhj"
